/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {unlinkBankAccount} from '../api'

export const useMutationUnlinkBankAccount = createReactQueryMutationHook('unlinkBankAccount', unlinkBankAccount)
